<template>
  <span
    ref="me"
    class="flex flex-row items-center"
  >
    <img
      v-if="building.happiness.level === 1"
      :src="`${require('@/assets/images/happiness1.png')}`"
      alt=""
      class="w-6 h-6"
    >
    <img
      v-else-if="building.happiness.level === 2"
      :src="`${require('@/assets/images/happiness2.png')}`"
      alt=""
      class="w-6 h-6"
    >
    <img
      v-else-if="building.happiness.level === 3"
      :src="`${require('@/assets/images/happiness3.png')}`"
      alt=""
      class="w-6 h-6"
    >
    <img
      v-else
      :src="`${require('@/assets/images/happiness0.png')}`"
      alt=""
      class="w-6 h-6"
    >
    <span class="ml-1">
      Culture: {{ building.happiness.value }} <span v-if="building.happiness.level < 3">({{
        building.happiness.required
      }} required for the next level)</span><span v-else>(Maxed)</span>
    </span>
  </span>
</template>

<script>
import {useLayoutStore} from '@/roc/stores/LayoutStore';
import {computed, readonly} from 'vue';

export default {
  props: {
    buildingId: {
      type: String,
      required: true
    },
  },
  setup (props) {
    const lytStore = useLayoutStore();

    return {
      building: computed(() => {
        return lytStore.buildings[props.buildingId];
      }),
    };
  },
};
</script>
